(() => {
  const init = (root) => {
    if (root.dataset.pmwReady === "true") return;
    root.dataset.pmwReady = "true";

    const launcher = root.querySelector("[data-pmw-open]");
    const panel = root.querySelector("[data-pmw-panel]");
    const closeButton = root.querySelector("[data-pmw-close]");
    const body = root.querySelector("[data-pmw-body]");
    const form = root.closest("form");
    const views = Array.from(root.querySelectorAll("[data-pmw-view]"));
    const message = root.querySelector("[data-pmw-message]");
    const messageError = root.querySelector("[data-pmw-message-error]");
    const hidden = Object.fromEntries(
      Array.from(root.querySelectorAll("[data-pmw-hidden]")).map((input) => [input.dataset.pmwHidden, input])
    );

    let currentView = root.dataset.pmwStartView || "home";
    let contactBackView = "home";

    const open = () => {
      panel.hidden = false;
      launcher.hidden = true;
      launcher.setAttribute("aria-expanded", "true");
      window.setTimeout(() => closeButton?.focus(), 0);
    };

    const close = () => {
      panel.hidden = true;
      launcher.hidden = false;
      launcher.setAttribute("aria-expanded", "false");
      launcher.focus();
    };

    const show = (name) => {
      const next = views.find((view) => view.dataset.pmwView === name);
      if (!next) return;
      views.forEach((view) => { view.hidden = view !== next; });
      currentView = name;
      body.scrollTop = 0;
      const heading = next.querySelector("h2");
      if (heading) {
        heading.setAttribute("tabindex", "-1");
        heading.focus({ preventScroll: true });
      }
    };

    const setMode = (mode) => {
      hidden.type.value = mode;
      hidden.need.value = "";
      hidden.width.value = "";
      hidden.control.value = "";
      hidden.time.value = "";
      if (message) {
        message.value = "";
        message.disabled = mode !== "Fråga";
      }
    };

    const goToContact = (backView) => {
      contactBackView = backView;
      show("contact");
    };

    launcher.addEventListener("click", open);
    closeButton.addEventListener("click", close);

    root.querySelectorAll("[data-pmw-start]").forEach((button) => {
      button.addEventListener("click", () => {
        const mode = button.dataset.pmwStart;
        if (mode === "guide") {
          setMode("Snabbguide");
          show("guide-need");
        } else if (mode === "callback") {
          setMode("Återuppringning");
          show("callback");
        } else {
          setMode("Fråga");
          show("message");
        }
      });
    });

    root.querySelectorAll("[data-pmw-show]").forEach((button) => {
      button.addEventListener("click", () => show(button.dataset.pmwShow));
    });

    root.querySelectorAll("[data-pmw-answer]").forEach((button) => {
      button.addEventListener("click", () => {
        const field = button.dataset.pmwAnswer;
        const value = button.dataset.pmwValue || "";
        const next = button.dataset.pmwNext;
        if (hidden[field]) hidden[field].value = value;

        root.querySelectorAll(`[data-pmw-answer="${field}"]`).forEach((item) => {
          const selected = item === button;
          item.classList.toggle("is-selected", selected);
          item.setAttribute("aria-pressed", selected ? "true" : "false");
        });

        if (next === "contact") goToContact(currentView);
        else show(next);
      });
    });

    root.querySelector("[data-pmw-message-next]")?.addEventListener("click", () => {
      const value = message.value.trim();
      if (!value) {
        messageError.hidden = false;
        message.focus();
        return;
      }
      messageError.hidden = true;
      goToContact("message");
    });

    root.querySelector("[data-pmw-contact-back]")?.addEventListener("click", () => show(contactBackView));

    root.querySelector("[data-pmw-reset]")?.addEventListener("click", close);

    form?.addEventListener("submit", (event) => {
      const honeypot = form.querySelector(".pmw__honeypot");
      if (honeypot?.value) {
        event.preventDefault();
        close();
        return;
      }

      hidden.page.value = window.location.href;
      const parts = [
        "Ny förfrågan via Markishjälpen",
        `Ärendetyp: ${hidden.type.value || "Ej angivet"}`,
        hidden.need.value ? `Behov: ${hidden.need.value}` : "",
        hidden.width.value ? `Ungefärlig bredd: ${hidden.width.value}` : "",
        hidden.control.value ? `Önskad styrning: ${hidden.control.value}` : "",
        hidden.time.value ? `Önskad kontakttid: ${hidden.time.value}` : "",
        message && !message.disabled && message.value.trim() ? `Fråga: ${message.value.trim()}` : "",
        `Sida: ${window.location.href}`
      ].filter(Boolean);
      hidden.body.value = parts.join("\n");
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !panel.hidden) close();
    });

    if (currentView === "success" || currentView === "contact") {
      show(currentView);
      open();
    } else {
      show("home");
    }
  };

  const boot = () => document.querySelectorAll("[data-pmw-root]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();

  document.addEventListener("shopify:section:load", boot);
})();
